import axios, {AxiosResponse} from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {Sektor} from '../models/Sektor'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/sektor`
const SEKTOR_DROPDOWN = `${API_URL}/sektorDropdown`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

// Get request for Sektor dropdown data.

export async function getSektorDropdown(): Promise<AxiosResponse<Array<Option>>> {
  return await axios.get<Array<Option>>(SEKTOR_DROPDOWN, {headers: headers})
}
export async function getSektor(): Promise<AxiosResponse<Array<Option>>> {
  return await axios.get<Array<Option>>(SEKTOR_DROPDOWN, {headers: headers})
}
export async function getAlSektor(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<Sektor>>(API, {headers: headers, params: params})
}
export async function saveSektor(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error Saving Sektor data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchSektor(Id: number): Promise<Partial<Sektor>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Sektor data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateSektor(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error Updating Sektor data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteSektor(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error deleting Sektor data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
